
import Vue from "vue";
import Component from "vue-class-component";

const PostValidationProps = Vue.extend({});

@Component({})
export default class PostValidation extends PostValidationProps {}
